module.exports = __webpack_public_path__ + "static/media/arrow-right.f4e3d346.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/PageSection/arrow-right.svg
// module id = 84
// module chunks = 0